import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as AnalyticsApi, CatalogItemViewsCountAvgDto, CatalogItemViewsCountsDto, CatalogViewsCountCatalogItemViewsCountPerDateDto, CatalogViewsCountCatalogItemViewsCountPerMonthDto, CatalogViewsCountCatalogItemViewsCountPerWeekDto, ViewsCountDto } from '@interfaces/HttpClient/AnalyticsApiModels';
import { firstValueFrom } from 'rxjs';
import { DaterangeService } from './daterange.service';

@Injectable({
	providedIn: 'root'
})
export class OrcaAdminViewService {

	constructor(
		private analyticsApi: AnalyticsApi,
		private requestService: RequestService,
		private daterangeService: DaterangeService) { }

	async getViewsCountAsync(): Promise<ViewsCountDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetViewsCount((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsCountsAsync(): Promise<CatalogItemViewsCountsDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetCatalogItemViewsCounts((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogItemViewsCountAvgAsync(): Promise<CatalogItemViewsCountAvgDto> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetCatalogItemViewsCountAvg((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogViewsCountCatalogItemViewsCountPerDate(): Promise<CatalogViewsCountCatalogItemViewsCountPerDateDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetCatalogViewsCountCatalogItemViewsCountPerDate((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogViewsCountCatalogItemViewsCountWeekly(): Promise<CatalogViewsCountCatalogItemViewsCountPerWeekDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetCatalogViewsCountCatalogItemViewsCountPerWeek((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getCatalogViewsCountCatalogItemViewsCountMonthly(): Promise<CatalogViewsCountCatalogItemViewsCountPerMonthDto[]> {
		try {
			return firstValueFrom(this.analyticsApi.orcaAdminView_GetCatalogViewsCountCatalogItemViewsCountPerMonth((await this.daterangeService.rangeInfo)?.rangeStart, (await this.daterangeService.rangeInfo)?.rangeEnd));
		}
		catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
